// Генерация плоского массива объектов папок с заполнением childsIds и счетчиков
import type { Folder, FolderTree } from './types';
import type { Props } from '../types';
import { useI18n } from '@/core/app';

export const folderDefault: Folder = {
	id: 0,
	name: '/',
	path: '/',
};

/**
 * Сгенерировать объект корневой папки для компонента
 *
 * Содержит измененное имя
 *
 * Необходимо предустанавливать для минимизации `rerender`
 */
export const genRootFolder = (folders: FolderTree | undefined, useSelectAll: boolean) => {
	let rootFolder = folders?.['root'][0] ?? folderDefault;
	rootFolder = { ...rootFolder };

	rootFolder.name = genRootFolderName(useSelectAll);

	return rootFolder;
};

function genRootFolderName(useSelectAll: boolean) {
	if (useSelectAll) {
		return useI18n()?.Common.All_folders;
	} else {
		return '/ (' + useI18n()?.Keywords.Root_folder + ')';
	}
}

/**
 * Сгенерировать плоский список папок
 *
 * В `folders` должен передаваться список всех папок, дозагрузка не предусмотрена
 */
export const genFlat = (
	folderById: NonNullable<Props['folders']>,
	useSelectAll: boolean,
	resultFolders = new Map<Folder['id'], Folder>(),
	parentFolder: Folder = { id: 'root' } as unknown as Folder,
	depth = 0,
) => {
	parentFolder.childsIds = [];

	if (parentFolder.id) {
		parentFolder.countAllGroupsActive = parentFolder.count_groups_active;
	}

	if (!folderById[parentFolder.id]) {
		return resultFolders;
	}

	folderById[parentFolder.id].forEach((folder) => {
		folder = { ...folder };

		parentFolder.childsIds!.push(folder.id);

		if (folder.id === 0) folder.name = genRootFolderName(useSelectAll);

		const prefix = depth > 1 ? '-'.repeat(depth - 1) + ' ' : '';
		if (prefix && !folder.name.startsWith(prefix)) folder.name = prefix + folder.name;

		resultFolders.set(folder.id, folder);

		genFlat(folderById, useSelectAll, resultFolders, folder, depth + 1);

		parentFolder.childsIds = parentFolder.childsIds!.concat(folder.childsIds!);

		if (parentFolder.id && folder.count_groups_active) {
			parentFolder.countAllGroupsActive! += folder.count_groups_active;
		}
	});

	return resultFolders;
};

/**
 * Создать API запрос на получение групп
 */
export const genApiGetFolders = (client: Api.Client<Api.TV.Paths, true>) => {
	return client.gen('/get/keywords_2/folders/', ['id', 'parent_id', 'name', 'path']).changeParams({ orders: ['ord_path'] as any, limit: 100 });
};
